import { render, staticRenderFns } from "./BriqDateRangePicker.vue?vue&type=template&id=10f20aa0&scoped=true&lang=pug&"
import script from "./BriqDateRangePicker.vue?vue&type=script&lang=js&"
export * from "./BriqDateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./BriqDateRangePicker.vue?vue&type=style&index=0&id=10f20aa0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f20aa0",
  null
  
)

export default component.exports